import {
	API_GET_ALL_CENTER,
	API_ADMIN_PATCH_CENTER,
	API_ADMIN_POST_CENTER,
	RESET_CENTER,
	API_ADMIN_DELETE_CENTER,
	API_ADMIN_GET_ALL_CENTER,
	API_ADMIN_GET_CENTER,
	ADMIN_INIT_NEW_CENTER,
	ADMIN_RESET_FOCUS_CENTER,
	API_ADMIN_IMPORT_CENTER,
	SET_CENTER,
	API_GET_MY_CENTERS,
	API_GET_CENTER_TOUR_STATUS,
	API_GET_CENTERS_MY_RDV,
	API_GET_APPOINTMENTS_FOR_CENTER,
} from "actions/center";

export function getAllCenters() {
	return {
		type: API_GET_ALL_CENTER,
		payload: {
			request: {
				url: `/centers`,
			},
		},
	};
}

export function getMyCenters() {
	return {
		type: API_GET_MY_CENTERS,
		payload: {
			request: {
				url: `/my-centers`,
			},
		},
	};
}

export function adminGetAllCenters() {
	return {
		type: API_ADMIN_GET_ALL_CENTER,
		payload: {
			request: {
				url: `/admin/centers`,
			},
		},
	};
}

export function adminGetCenterById(patientId) {
	return {
		type: API_ADMIN_GET_CENTER,
		payload: {
			request: {
				url: `/admin/centers/${patientId}`,
			},
		},
	};
}

export function adminPatchCenter(patient) {
	return {
		type: API_ADMIN_PATCH_CENTER,
		payload: {
			request: {
				url: `/admin/centers/${patient.id}`,
				method: "PATCH",
				data: patient,
			},
		},
	};
}

export function adminPostCenter(patient) {
	return {
		type: API_ADMIN_POST_CENTER,
		payload: {
			request: {
				url: `/admin/centers`,
				method: "POST",
				data: patient,
			},
		},
	};
}

export function adminDeleteCenter(patientId) {
	return {
		type: API_ADMIN_DELETE_CENTER,
		payload: {
			request: {
				url: `/admin/centers/${patientId}`,
				method: "delete",
			},
		},
	};
}

export function adminImportCenters(file) {
	const formData = new FormData();
	formData.append("file", file);
	return {
		type: API_ADMIN_IMPORT_CENTER,
		payload: {
			request: {
				config: { headers: { "Content-Type": "multipart/form-data" } },
				url: `/admin/import/centers`,
				method: "post",
				data: formData,
			},
		},
	};
}

export function resetCenter() {
	return {
		type: RESET_CENTER,
		payload: null,
	};
}

export function setCenter(center) {
	return {
		type: SET_CENTER,
		payload: center,
	};
}

export function initNewCenter() {
	return {
		type: ADMIN_INIT_NEW_CENTER,
	};
}

export function resetFocusCenter() {
	return {
		type: ADMIN_RESET_FOCUS_CENTER,
	};
}

export function getMyCenterTourStatus() {
	return {
		type: API_GET_CENTER_TOUR_STATUS,
		payload: {
			request: {
				url: `/tour/status`,
			},
		},
	};
}

export function getCentersMyRdv() {
	return {
		type: API_GET_CENTERS_MY_RDV,
		payload: {
			request: {
				url: `/centers/my-rdv`,
			},
		},
	};
}

export function getAppointmentsForCenter(date, centerId) {
	return {
		type: API_GET_APPOINTMENTS_FOR_CENTER,
		payload: {
			request: {
				url: `centers/planning/${centerId}?date=${date.toISOString()}`,
			},
		},
	};
}
